/**
 * Fabpad PDP — variants, gallery, sticky ATC, AJAX add to bag.
 */
(function () {
  'use strict';

  var GUIDE_TYPES = { care: true, size: true, flow: true, style: true };

  function closeGuideModals() {
    document.querySelectorAll('[data-guide-modal]').forEach(function (modal) {
      modal.hidden = true;
      modal.setAttribute('hidden', '');
    });
    document.body.classList.remove('pdp-guide-modal-open');
    document.querySelectorAll('[data-guide-open]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  function openGuideModal(type) {
    if (!GUIDE_TYPES[type]) return;
    closeGuideModals();
    var modal = document.querySelector('[data-guide-modal="' + type + '"]');
    if (!modal) return;
    document.body.appendChild(modal);
    modal.hidden = false;
    modal.removeAttribute('hidden');
    document.body.classList.add('pdp-guide-modal-open');
    var opener = document.querySelector('[data-guide-open="' + type + '"]');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    var closeBtn = modal.querySelector('.pdp-guide-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function parkGuideModals() {
    document.querySelectorAll('[data-guide-modal]').forEach(function (modal) {
      document.body.appendChild(modal);
    });
  }

  function closestFrom(target, selector) {
    var el = target;
    if (el && el.nodeType !== 1) el = el.parentElement;
    while (el && typeof el.closest !== 'function') {
      el = el.parentElement;
    }
    return el ? el.closest(selector) : null;
  }

  function loadAboutVideoFacade(btn) {
    if (!btn || btn.getAttribute('data-video-loaded') === 'true') return;
    var provider = btn.getAttribute('data-video-provider');
    var id = btn.getAttribute('data-video-id');
    if (!id || !btn.parentNode) return;

    var src = '';
    if (provider === 'youtube') {
      src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?rel=0&autoplay=1';
    } else if (provider === 'vimeo') {
      src = 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1';
    }
    if (!src) return;

    btn.setAttribute('data-video-loaded', 'true');

    var iframe = document.createElement('iframe');
    iframe.className = 'pdp-about__external-video';
    iframe.src = src;
    iframe.title = btn.getAttribute('aria-label') || 'Product video';
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');

    btn.parentNode.replaceChild(iframe, btn);
  }

  document.addEventListener('click', function (e) {
    var facade = closestFrom(e.target, '[data-video-facade]');
    if (facade) {
      e.preventDefault();
      loadAboutVideoFacade(facade);
      return;
    }
    var closeEl = closestFrom(e.target, '[data-guide-close]');
    if (closeEl) {
      e.preventDefault();
      closeGuideModals();
      return;
    }
    var openBtn = closestFrom(e.target, '[data-guide-open]');
    if (!openBtn) return;
    e.preventDefault();
    openGuideModal(openBtn.getAttribute('data-guide-open'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeGuideModals();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', parkGuideModals);
  } else {
    parkGuideModals();
  }

  document.addEventListener('DOMContentLoaded', function () {
    var pdp = document.querySelector('[data-pdp]');
    if (!pdp) return;

    var configEl = document.querySelector('[data-pdp-config]');
    var variantsEl = document.querySelector('[data-pdp-variants]');
    if (!configEl || !variantsEl) return;

    var config;
    var variants;
    try {
      config = JSON.parse(configEl.textContent);
      variants = JSON.parse(variantsEl.textContent);
    } catch (err) {
      return;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    var selectedColor = config.hasColorOption ? (config.defaultColor || '') : '';
    var selectedSize = config.requireSize ? '' : config.defaultSize;
    var selectedPack = config.requireSize ? '' : (config.defaultPack || '');

    var variantInput = document.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-pdp-price]');
    var compareEl = document.querySelector('[data-pdp-compare]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var mainAtc = document.querySelector('[data-main-atc]');
    var stickyAtc = document.querySelector('[data-sticky-atc]');
    var stickyAtcBtn = document.querySelector('[data-sticky-atc-button]');
    var colorLabel = document.querySelector('[data-color-label]');
    var sizeLabel = document.querySelector('[data-size-label]');
    var packLabel = document.querySelector('[data-pack-label]');
    var colorButtons = document.querySelectorAll('[data-color-option]');
    var sizeButtons = document.querySelectorAll('[data-size-option]');
    var packButtons = document.querySelectorAll('[data-pack-option]');
    var atcError = document.querySelector('[data-atc-error]');
    var staticOptionLabels = pdp.querySelector('.pdp-buy-box--fabpad-pdp') !== null;
    var qtyInput = document.querySelector('[data-qty-input]');
    var qtyMinus = document.querySelector('[data-qty-minus]');
    var qtyPlus = document.querySelector('[data-qty-plus]');

    function getQty() {
      if (!qtyInput) return 1;
      var qty = parseInt(qtyInput.value, 10);
      if (isNaN(qty) || qty < 1) qty = 1;
      if (qty > 20) qty = 20;
      qtyInput.value = String(qty);
      return qty;
    }

    function getSellingPlanId() {
      var input = document.querySelector('[data-selling-plan]');
      if (!input) return null;
      var id = parseInt(input.value, 10);
      return id > 0 ? id : null;
    }

    function buildCartAddPayload(variantId, quantity) {
      var payload = { id: Number(variantId), quantity: quantity };
      var sellingPlan = getSellingPlanId();
      if (sellingPlan) payload.selling_plan = sellingPlan;
      return payload;
    }

    function allocationForPlan(variant, planId) {
      if (!variant || !planId || !variant.selling_plan_allocations) return null;
      return variant.selling_plan_allocations.find(function (allocation) {
        return String(allocation.selling_plan_id) === String(planId);
      }) || null;
    }

    if (qtyMinus) {
      qtyMinus.addEventListener('click', function () {
        if (!qtyInput) return;
        qtyInput.value = String(Math.max(1, getQty() - 1));
      });
    }

    if (qtyPlus) {
      qtyPlus.addEventListener('click', function () {
        if (!qtyInput) return;
        qtyInput.value = String(Math.min(20, getQty() + 1));
      });
    }

    var sellingPlanInput = document.querySelector('[data-selling-plan]');
    var subscribeRoot = document.querySelector('[data-selling-plans]');
    var subscribeToggle = subscribeRoot ? subscribeRoot.querySelector('[data-subscribe-toggle]') : null;
    var frequencySelect = subscribeRoot ? subscribeRoot.querySelector('[data-selling-plan-frequency]') : null;
    var freqTrigger = subscribeRoot ? subscribeRoot.querySelector('[data-freq-trigger]') : null;
    var freqList = subscribeRoot ? subscribeRoot.querySelector('[data-freq-list]') : null;
    var freqLabel = subscribeRoot ? subscribeRoot.querySelector('[data-freq-label]') : null;
    var howBtn = subscribeRoot ? subscribeRoot.querySelector('[data-subscribe-how]') : null;
    var howPanel = subscribeRoot ? subscribeRoot.querySelector('[data-subscribe-how-panel]') : null;

    function isSubscribeOn() {
      return !!(subscribeToggle && subscribeToggle.checked);
    }

    function closeFreqList() {
      if (!subscribeRoot) return;
      var wrap = subscribeRoot.querySelector('[data-freq-select]');
      if (freqList) freqList.hidden = true;
      if (freqTrigger) freqTrigger.setAttribute('aria-expanded', 'false');
      if (wrap) wrap.classList.remove('is-open');
    }

    function syncSellingPlanInput() {
      if (!sellingPlanInput) return;
      if (isSubscribeOn() && frequencySelect && frequencySelect.value) {
        sellingPlanInput.value = frequencySelect.value;
      } else {
        sellingPlanInput.value = '';
      }
      if (subscribeRoot) subscribeRoot.classList.toggle('is-selected', isSubscribeOn());
    }

    function applySubscribePricing() {
      syncSellingPlanInput();
      var variant = findActiveVariant();
      if (!variant) return;
      updateSubscribeWidgetPrice(variant);
      if (!window.FabpadCombos || !window.FabpadCombos.isActive()) {
        restoreSinglePricing(variant);
      }
    }

    function setSubscribeOn(on, options) {
      if (subscribeToggle) subscribeToggle.checked = !!on;
      if (on && window.FabpadCombos && window.FabpadCombos.isActive()) {
        window.FabpadCombos.clearSelection();
      }
      applySubscribePricing();
      if (options && options.closeFreq) closeFreqList();
    }

    function updateSubscribeWidgetPrice(variant) {
      if (!subscribeRoot || !variant) return;
      var priceNode = subscribeRoot.querySelector('[data-subscribe-price]');
      var offNode = subscribeRoot.querySelector('[data-subscribe-off]');
      var planId = frequencySelect && frequencySelect.value;
      var allocation = allocationForPlan(variant, planId);
      var savePct = parseInt(subscribeRoot.getAttribute('data-save-percent'), 10);
      if (isNaN(savePct) || savePct < 1) savePct = 10;
      var price = variant.price;
      if (allocation && allocation.price != null) {
        price = allocation.price;
        if (variant.price > 0 && allocation.price < variant.price) {
          savePct = Math.round((1 - allocation.price / variant.price) * 100);
        }
      } else {
        price = Math.round(variant.price * (100 - savePct) / 100);
      }
      if (priceNode) priceNode.textContent = formatMoney(price);
      if (offNode) offNode.textContent = '(' + savePct + '% Off)';
    }

    if (subscribeToggle) {
      subscribeToggle.addEventListener('change', function () {
        setSubscribeOn(subscribeToggle.checked);
      });
    }

    if (freqTrigger && freqList) {
      freqTrigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var open = freqList.hidden;
        closeFreqList();
        if (open) {
          freqList.hidden = false;
          freqTrigger.setAttribute('aria-expanded', 'true');
          var wrap = subscribeRoot.querySelector('[data-freq-select]');
          if (wrap) wrap.classList.add('is-open');
        }
      });

      freqList.querySelectorAll('[data-plan-id]').forEach(function (option) {
        option.addEventListener('click', function () {
          var planId = option.getAttribute('data-plan-id');
          var label = option.getAttribute('data-plan-label') || option.textContent.trim();
          if (frequencySelect) frequencySelect.value = planId;
          if (freqLabel) freqLabel.textContent = label;
          freqList.querySelectorAll('[data-plan-id]').forEach(function (item) {
            var selected = item === option;
            item.classList.toggle('is-selected', selected);
            item.setAttribute('aria-selected', selected ? 'true' : 'false');
          });
          setSubscribeOn(true, { closeFreq: true });
        });
      });

      document.addEventListener('click', function (event) {
        if (!subscribeRoot.contains(event.target)) closeFreqList();
      });
    }

    if (howBtn && howPanel) {
      howBtn.addEventListener('click', function () {
        howPanel.hidden = !howPanel.hidden;
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        getQty();
      });
    }

    if (variantInput && variantInput.value) {
      var initialVariant = variants.find(function (v) {
        return String(v.id) === String(variantInput.value);
      });
      if (initialVariant) {
        selectedColor = getOptionValue(initialVariant, config.colorPosition);
        if (!config.requireSize) {
          selectedSize = getOptionValue(initialVariant, config.sizePosition);
          if (config.hasPackOption) {
            selectedPack = getOptionValue(initialVariant, config.packPosition);
          }
        }
      }
    }

    function getSizeDisplayLabel(sizeValue) {
      var match = Array.prototype.find.call(sizeButtons, function (btn) {
        return btn.dataset.sizeOption === sizeValue;
      });
      return (match && match.dataset.sizeLabel) || sizeValue;
    }

    function getOptionValue(variant, position) {
      if (!position) return '';
      if (position === 1) return variant.option1;
      if (position === 2) return variant.option2;
      return variant.option3;
    }

    function firstAvailableVariantForSize(sizeValue) {
      return variants.find(function (item) {
        return getOptionValue(item, config.sizePosition) === sizeValue && item.available;
      });
    }

    function kitSizeReady() {
      if (!config.requireSize) return true;
      if (!selectedSize) return false;
      if (config.hasPackOption && !selectedPack) return false;
      return true;
    }

    function findActiveVariant() {
      if (config.requireSize && !kitSizeReady()) return null;
      if (config.hasPackOption) {
        var matched = variants.find(function (variant) {
          return (
            getOptionValue(variant, config.sizePosition) === selectedSize &&
            getOptionValue(variant, config.packPosition) === selectedPack
          );
        });
        if (matched && matched.available) return matched;

        if (config.requireSize) return matched || null;

        var fallback = firstAvailableVariantForSize(selectedSize);
        if (fallback) {
          selectedPack = getOptionValue(fallback, config.packPosition);
          return fallback;
        }
        return matched || null;
      }

      if (config.hasColorOption) {
        return variants.find(function (variant) {
          return (
            getOptionValue(variant, config.colorPosition) === selectedColor &&
            getOptionValue(variant, config.sizePosition) === selectedSize
          );
        });
      }

      return variants.find(function (variant) {
        return getOptionValue(variant, config.sizePosition) === selectedSize;
      });
    }

    function updatePackAvailability() {
      packButtons.forEach(function (btn) {
        var variant = variants.find(function (item) {
          return (
            getOptionValue(item, config.sizePosition) === selectedSize &&
            getOptionValue(item, config.packPosition) === btn.dataset.packOption
          );
        });
        var available = !!(variant && variant.available);
        btn.classList.toggle('is-unavailable', !available);
        btn.setAttribute('aria-disabled', available ? 'false' : 'true');
      });
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, config.moneyFormat);
      }
      return '₹' + Math.round(cents / 100);
    }

    function updateUrl(variant) {
      if (!variant || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    function setAtcState(btn, available) {
      if (!btn) return;
      btn.classList.remove('is-loading', 'is-success');
      if (available) {
        btn.disabled = false;
        btn.classList.remove('pdp-atc-button--oos');
        btn.textContent = btn === stickyAtcBtn ? 'Add to cart' : 'Add to cart';
      } else {
        btn.disabled = true;
        btn.classList.add('pdp-atc-button--oos');
        btn.textContent = 'BACK SOON';
      }
    }

    function setBuyNowVisibility(available) {
      var buyNow = document.querySelector('[data-buy-it-now]');
      if (!buyNow) return;
      buyNow.hidden = !available;
      buyNow.disabled = !available;
      buyNow.classList.toggle('is-hidden', !available);
    }

    function findVariantForGallery() {
      var variant = findActiveVariant();
      if (variant && (variant.featured_media_id || (variant.featured_image && variant.featured_image.src))) {
        return variant;
      }

      if (config.hasColorOption && selectedColor) {
        return variants.find(function (item) {
          return (
            getOptionValue(item, config.colorPosition) === selectedColor &&
            (item.featured_media_id || (item.featured_image && item.featured_image.src))
          );
        });
      }

      return variant;
    }

    function updateGalleryForVariant(variant) {
      if (gallery && gallery.dataset.galleryMode === 'variant') {
        setGalleryForVariant(variant);
        return;
      }

      if (config.hasColorOption && selectedColor && setGalleryForColor(selectedColor)) {
        return;
      }

      if (setGalleryForVariant(variant)) {
        return;
      }

      if (!variant) return;

      var mediaId = variant.featured_media_id ||
        (variant.featured_media && variant.featured_media.id) ||
        (variant.featured_image && variant.featured_image.id);
      var imageSrc = variant.featured_image && variant.featured_image.src;
      var imageAlt = variant.featured_image && variant.featured_image.alt;

      if (!mediaId && !imageSrc) return;

      if (!goToMediaId(mediaId, imageSrc)) {
        updateGalleryImageDirect(imageSrc, imageAlt, mediaId);
      }
    }

    function updateGalleryImageDirect(imageSrc, alt, mediaId) {
      if (!imageSrc) return;

      var targetSlide = slides[0];
      if (targetSlide) {
        var slideImg = targetSlide.querySelector('img.pdp-gallery__main-image');
        if (slideImg) {
          slideImg.src = imageSrc;
          slideImg.removeAttribute('srcset');
          slideImg.removeAttribute('sizes');
          if (alt) slideImg.alt = alt;
        }
        if (mediaId) {
          targetSlide.dataset.mediaId = mediaId;
        }
        goToSlide(0);
        return;
      }

      if (mainStage) {
        var mainImg = mainStage.querySelector('img.pdp-gallery__main-image');
        if (mainImg) {
          mainImg.src = imageSrc;
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          if (alt) mainImg.alt = alt;
        }
      }
    }

    function updateVariantUI() {
      var variant = findActiveVariant();

      if (!config.requireSize && !variant && config.hasPackOption && variants.length) {
        variant = variants.find(function (item) {
          return (
            getOptionValue(item, config.sizePosition) === selectedSize &&
            getOptionValue(item, config.packPosition) === selectedPack &&
            item.available
          );
        }) || variants.find(function (item) {
          return getOptionValue(item, config.sizePosition) === selectedSize && item.available;
        });

        if (variant) {
          selectedPack = getOptionValue(variant, config.packPosition);
        }
      }

      if (!config.requireSize && !variant && variants.length && !config.hasPackOption) {
        if (config.hasColorOption) {
          variant = variants.find(function (v) {
            return (
              getOptionValue(v, config.colorPosition) === selectedColor &&
              getOptionValue(v, config.sizePosition) === selectedSize
            );
          });
        } else {
          variant = variants.find(function (v) {
            return getOptionValue(v, config.sizePosition) === selectedSize;
          });
        }

        if (!variant) {
          variant = variants.find(function (v) { return v.available; }) || variants[0];
          if (config.hasColorOption) selectedColor = getOptionValue(variant, config.colorPosition);
          selectedSize = getOptionValue(variant, config.sizePosition);
        }
      }

      if (!config.requireSize && !variant && variants.length && config.hasPackOption) {
        variant = variants.find(function (v) { return v.available; }) || variants[0];
        selectedSize = getOptionValue(variant, config.sizePosition);
        selectedPack = getOptionValue(variant, config.packPosition);
      }

      colorButtons.forEach(function (btn) {
        var isSelected = btn.dataset.colorOption === selectedColor;
        btn.classList.toggle('is-selected', isSelected);
        btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      sizeButtons.forEach(function (btn) {
        var sizeValue = btn.dataset.sizeOption;
        var sizeVariant;
        if (config.hasPackOption) {
          sizeVariant = firstAvailableVariantForSize(sizeValue);
        } else if (config.hasColorOption) {
          sizeVariant = variants.find(function (item) {
            return (
              getOptionValue(item, config.colorPosition) === selectedColor &&
              getOptionValue(item, config.sizePosition) === sizeValue
            );
          });
        } else {
          sizeVariant = variants.find(function (item) {
            return getOptionValue(item, config.sizePosition) === sizeValue;
          });
        }
        var isSelected = sizeValue === selectedSize;
        var isAvailable = sizeVariant && sizeVariant.available;

        btn.classList.toggle('is-selected', isSelected);
        btn.classList.toggle('is-unavailable', !isAvailable);
        btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        if (isAvailable) {
          btn.removeAttribute('aria-disabled');
        } else {
          btn.setAttribute('aria-disabled', 'true');
        }
      });

      packButtons.forEach(function (btn) {
        var isSelected = btn.dataset.packOption === selectedPack;
        btn.classList.toggle('is-selected', isSelected);
        btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      if (config.hasPackOption) {
        updatePackAvailability();
      }

      if (colorLabel) {
        colorLabel.textContent = staticOptionLabels ? 'Select colour' : 'Colour — ' + selectedColor;
      }
      var variantLineColor = document.querySelector('[data-variant-line-color]');
      if (variantLineColor && selectedColor) {
        variantLineColor.textContent = selectedColor;
      }
      if (sizeLabel) {
        if (staticOptionLabels) {
          sizeLabel.textContent = sizeLabel.getAttribute('data-label-static') || 'Select size';
        } else if (config.hasPackOption) {
          sizeLabel.textContent = 'Select size — ' + selectedSize;
        } else {
          sizeLabel.textContent = 'Size — ' + getSizeDisplayLabel(selectedSize);
        }
      }
      if (packLabel) {
        if (staticOptionLabels) {
          packLabel.textContent = packLabel.getAttribute('data-label-static') || 'Select pack';
        } else {
          packLabel.textContent = 'Select pack — ' + selectedPack;
        }
      }

      if (!variant) {
        if (config.requireSize) {
          if (mainAtc) {
            mainAtc.disabled = true;
            mainAtc.classList.remove('pdp-atc-button--oos', 'is-loading', 'is-success');
            mainAtc.textContent = 'Select size';
          }
          if (stickyAtcBtn) {
            stickyAtcBtn.disabled = true;
            stickyAtcBtn.classList.remove('pdp-sticky-atc__button--oos', 'is-loading', 'is-success');
            stickyAtcBtn.textContent = 'Select size';
          }
          setBuyNowVisibility(false);
        }
        return;
      }

      if (variantInput) variantInput.value = variant.id;

      setAtcState(mainAtc, variant.available);
      setAtcState(stickyAtcBtn, variant.available);
      setBuyNowVisibility(variant.available);
      if (stickyAtcBtn && variant.available) {
        stickyAtcBtn.classList.remove('pdp-sticky-atc__button--oos');
      } else if (stickyAtcBtn) {
        stickyAtcBtn.classList.add('pdp-sticky-atc__button--oos');
      }

      updateUrl(variant);

      updateGalleryForVariant(findVariantForGallery());

      syncComboSlotDefaults();
      document.dispatchEvent(new CustomEvent('fabpad:variant-change', {
        detail: {
          color: selectedColor,
          size: selectedSize,
          pack: selectedPack,
          variant: variant
        }
      }));

      if (!window.FabpadCombos || !window.FabpadCombos.isActive()) {
        restoreSinglePricing(variant);
      } else {
        updateSubscribeWidgetPrice(variant);
      }
    }

    document.addEventListener('fabpad:combo-change', function (event) {
      if (event.detail && event.detail.active) {
        if (subscribeToggle && subscribeToggle.checked) {
          subscribeToggle.checked = false;
          syncSellingPlanInput();
        }
        return;
      }
      var variant = findActiveVariant();
      if (variant) {
        restoreSinglePricing(variant);
        setAtcState(mainAtc, variant.available);
        setAtcState(stickyAtcBtn, variant.available);
        setBuyNowVisibility(variant.available);
      }
    });

    function restoreSinglePricing(variant) {
      if (!variant) return;
      var planId = getSellingPlanId();
      var allocation = allocationForPlan(variant, planId);
      var price = allocation && allocation.price != null ? allocation.price : variant.price;
      var compare = allocation && allocation.compare_at_price != null
        ? allocation.compare_at_price
        : variant.compare_at_price;
      var priceText = formatMoney(price);
      if (priceEl) priceEl.textContent = priceText;
      if (stickyPrice) stickyPrice.textContent = priceText;
      if (compareEl) {
        if (compare && compare > price) {
          compareEl.textContent = formatMoney(compare);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      updateSubscribeWidgetPrice(variant);
    }

    function syncComboSlotDefaults() {
      var combosRoot = document.querySelector('[data-pdp-combos]');
      if (!combosRoot) return;

      var activeVariant = findActiveVariant();

      combosRoot.querySelectorAll('[data-combo-tier]').forEach(function (tier) {
        tier.querySelectorAll('[data-combo-size-select]').forEach(function (el) {
          if (selectedSize) el.value = selectedSize;
        });
        tier.querySelectorAll('[data-combo-color-select]').forEach(function (el) {
          if (selectedColor) el.value = selectedColor;
        });
        tier.querySelectorAll('[data-combo-pack-select]').forEach(function (el) {
          if (selectedPack) el.value = selectedPack;
        });
        if (activeVariant) {
          tier.querySelectorAll('[data-combo-variant-select]').forEach(function (el) {
            el.value = String(activeVariant.id);
          });
        }
      });
    }

    colorButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (window.FabpadCombos && window.FabpadCombos.isActive()) {
          window.FabpadCombos.clearSelection();
        }
        selectedColor = btn.dataset.colorOption;
        updateVariantUI();
      });
    });

    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (window.FabpadCombos && window.FabpadCombos.isActive()) {
          window.FabpadCombos.clearSelection();
        }
        if (btn.classList.contains('is-unavailable')) return;
        selectedSize = btn.dataset.sizeOption;
        updateVariantUI();
      });
    });

    packButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (window.FabpadCombos && window.FabpadCombos.isActive()) {
          window.FabpadCombos.clearSelection();
        }
        if (btn.classList.contains('is-unavailable')) return;
        selectedPack = btn.dataset.packOption;
        updateVariantUI();
      });
    });

    /* Gallery */
    var gallery = document.querySelector('[data-pdp-gallery]');
    var mainStage = document.querySelector('[data-gallery-main-stage]');
    var track = document.querySelector('[data-gallery-track]');
    var thumbsRoot = document.querySelector('[data-gallery-thumbs]');
    var dotsRoot = document.querySelector('[data-gallery-dots]');
    var countRoot = document.querySelector('[data-gallery-count]');
    var countCurrent = countRoot ? countRoot.querySelector('[data-gallery-count-current]') : null;
    var countTotal = countRoot ? countRoot.querySelector('[data-gallery-count-total]') : null;
    var prevBtn = document.querySelector('[data-gallery-prev]');
    var nextBtn = document.querySelector('[data-gallery-next]');
    var slides = gallery ? gallery.querySelectorAll('[data-gallery-slide]') : [];
    var dots = gallery ? gallery.querySelectorAll('[data-gallery-dot]') : [];
    var thumbs = gallery ? gallery.querySelectorAll('[data-gallery-thumb]') : [];
    var lightbox = document.querySelector('[data-pdp-lightbox]');
    var lightboxImage = document.querySelector('[data-pdp-lightbox-image]');
    var currentSlide = 0;
    var touchStartX = 0;
    var galleryLimit = gallery ? parseInt(gallery.dataset.galleryLimit || '6', 10) : 6;
    var galleryByColor = {};
    var galleryByColorEl = document.querySelector('[data-pdp-gallery-by-color]');
    var galleryByVariant = {};
    var galleryByVariantEl = document.querySelector('[data-pdp-gallery-by-variant]');
    var activeGalleryColor = '';
    var activeGalleryKey = '';
    var galleryAutoplayTimer = null;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var GALLERY_AUTOPLAY_MS = 3500;
    var GALLERY_MANUAL_HOLD_MS = 5000;
    var galleryAutoplayDelay = GALLERY_AUTOPLAY_MS;

    if (galleryByColorEl) {
      try {
        galleryByColor = JSON.parse(galleryByColorEl.textContent) || {};
      } catch (err) {
        galleryByColor = {};
      }
    }

    if (galleryByVariantEl) {
      try {
        galleryByVariant = JSON.parse(galleryByVariantEl.textContent) || {};
      } catch (err) {
        galleryByVariant = {};
      }
    }

    function refreshGalleryNodes() {
      slides = gallery ? gallery.querySelectorAll('[data-gallery-slide]') : [];
      dots = gallery ? gallery.querySelectorAll('[data-gallery-dot]') : [];
      thumbs = gallery ? gallery.querySelectorAll('[data-gallery-thumb]') : [];
      updateGalleryCount();
    }

    function updateGalleryCount() {
      if (!countRoot) return;
      var total = slides.length;
      countRoot.hidden = total < 2;
      if (countCurrent) countCurrent.textContent = String(currentSlide + 1);
      if (countTotal) countTotal.textContent = String(total);
    }

    function stopGalleryAutoplay() {
      if (galleryAutoplayTimer) {
        window.clearTimeout(galleryAutoplayTimer);
        galleryAutoplayTimer = null;
      }
    }

    function startGalleryAutoplay(holdMs) {
      stopGalleryAutoplay();
      if (prefersReducedMotion.matches || slides.length < 2) return;
      galleryAutoplayDelay = typeof holdMs === 'number' ? holdMs : GALLERY_AUTOPLAY_MS;
      galleryAutoplayTimer = window.setTimeout(function tick() {
        goToSlide(currentSlide + 1, true);
        galleryAutoplayDelay = GALLERY_AUTOPLAY_MS;
        galleryAutoplayTimer = window.setTimeout(tick, galleryAutoplayDelay);
      }, galleryAutoplayDelay);
    }

    function restartGalleryAutoplay() {
      startGalleryAutoplay(GALLERY_MANUAL_HOLD_MS);
    }

    function bindThumbAndDotClicks() {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          goToSlide(parseInt(thumb.dataset.galleryThumb, 10));
          restartGalleryAutoplay();
        });
      });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goToSlide(parseInt(dot.dataset.galleryDot, 10));
          restartGalleryAutoplay();
        });
      });
    }

    function pauseGalleryVideos(container) {
      if (!container) return;
      container.querySelectorAll('video').forEach(function (video) {
        video.pause();
      });
    }

    function getSlideImageSrc(slide) {
      var img = slide ? slide.querySelector('img.pdp-gallery__main-image') : null;
      return img ? img.src : '';
    }

    function syncMainStage(index) {
      if (!mainStage || !slides[index]) return;
      var slideContent = slides[index].querySelector('[data-gallery-slide-content]');
      if (!slideContent) return;

      pauseGalleryVideos(mainStage);
      mainStage.innerHTML = '';
      var clone = slideContent.cloneNode(true);
      clone.removeAttribute('data-gallery-slide-content');
      clone.classList.add('pdp-gallery__main-item');
      mainStage.appendChild(clone);
    }

    function goToSlide(index, wrap) {
      if (!track || !slides.length) return;
      if (wrap) {
        currentSlide = ((index % slides.length) + slides.length) % slides.length;
      } else {
        currentSlide = Math.max(0, Math.min(index, slides.length - 1));
      }
      track.style.transform = 'translateX(-' + currentSlide * 100 + '%)';
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === currentSlide);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentSlide);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === currentSlide);
      });
      scrollActiveThumbIntoView();
      syncMainStage(currentSlide);
      updateGalleryCount();
    }

    function scrollActiveThumbIntoView() {
      var activeThumb = thumbs[currentSlide];
      if (!activeThumb || !thumbsRoot) return;
      var rootRect = thumbsRoot.getBoundingClientRect();
      var thumbRect = activeThumb.getBoundingClientRect();
      var pad = 8;
      if (thumbRect.left < rootRect.left + pad) {
        thumbsRoot.scrollBy({ left: thumbRect.left - rootRect.left - pad, behavior: 'smooth' });
      } else if (thumbRect.right > rootRect.right - pad) {
        thumbsRoot.scrollBy({ left: thumbRect.right - rootRect.right + pad, behavior: 'smooth' });
      }
    }

    function imageKey(src) {
      if (!src) return '';
      try {
        return new URL(src, window.location.origin).pathname.split('/').pop().split('?')[0];
      } catch (err) {
        return src.split('/').pop().split('?')[0];
      }
    }

    function goToMediaId(mediaId, imageSrc) {
      var targetIndex = -1;

      slides.forEach(function (slide, i) {
        if (targetIndex !== -1) return;
        if (mediaId && (
          String(slide.dataset.mediaId) === String(mediaId) ||
          (slide.dataset.imageId && String(slide.dataset.imageId) === String(mediaId))
        )) {
          targetIndex = i;
        }
      });

      if (targetIndex === -1 && imageSrc) {
        var targetKey = imageKey(imageSrc);
        slides.forEach(function (slide, i) {
          if (targetIndex !== -1) return;
          if (imageKey(getSlideImageSrc(slide)) === targetKey) {
            targetIndex = i;
          }
        });
      }

      if (targetIndex !== -1) {
        goToSlide(targetIndex);
        return true;
      }

      return false;
    }

    function rebuildGalleryFromImages(images, cacheKey) {
      if (!gallery || !track || !images || !images.length) return false;
      if (activeGalleryKey === cacheKey && slides.length === Math.min(images.length, galleryLimit)) {
        goToSlide(0);
        restartGalleryAutoplay();
        return true;
      }

      var limited = images.slice(0, galleryLimit);
      activeGalleryKey = cacheKey;

      track.innerHTML = limited.map(function (item, index) {
        var mediaId = item.id;
        var imageId = item.imageId || item.id;
        return (
          '<li class="pdp-gallery__slide' + (index === 0 ? ' is-active' : '') + '" data-gallery-slide data-media-id="' + mediaId + '" data-image-id="' + imageId + '" data-media-type="image">' +
            '<div class="pdp-gallery__slide-inner" data-gallery-slide-content>' +
              '<img src="' + item.src + '" class="pdp-gallery__main-image" alt="' + (item.alt || '').replace(/"/g, '&quot;') + '" loading="' + (index === 0 ? 'eager' : 'lazy') + '" width="1200" height="1500">' +
            '</div>' +
          '</li>'
        );
      }).join('');

      if (thumbsRoot) {
        thumbsRoot.innerHTML = limited.map(function (item, index) {
          return (
            '<button type="button" class="pdp-gallery__thumb' + (index === 0 ? ' is-active' : '') + '" data-gallery-thumb="' + index + '" aria-label="View image ' + (index + 1) + '">' +
              '<img src="' + item.thumb + '" loading="lazy" alt="">' +
            '</button>'
          );
        }).join('');
        thumbsRoot.hidden = limited.length < 2;
      }

      if (dotsRoot) {
        dotsRoot.innerHTML = limited.map(function (_item, index) {
          return (
            '<button type="button" class="pdp-gallery__dot' + (index === 0 ? ' is-active' : '') + '" data-gallery-dot="' + index + '" role="tab" aria-label="Image ' + (index + 1) + ' of ' + limited.length + '"></button>'
          );
        }).join('');
        dotsRoot.hidden = limited.length < 2;
      }

      refreshGalleryNodes();
      bindThumbAndDotClicks();
      goToSlide(0);
      restartGalleryAutoplay();
      return true;
    }

    function setGalleryForColor(colorName) {
      if (!colorName) return false;
      var images = galleryByColor[colorName];
      if (!images || !images.length) return false;
      activeGalleryColor = colorName;
      return rebuildGalleryFromImages(images, 'color:' + colorName);
    }

    function setGalleryForVariant(variant) {
      if (!variant || !variant.id) return false;
      var images = galleryByVariant[String(variant.id)];
      if (!images || !images.length) return false;
      return rebuildGalleryFromImages(images, 'variant:' + variant.id);
    }

    bindThumbAndDotClicks();
    updateGalleryCount();

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToSlide(currentSlide - 1, true);
        restartGalleryAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToSlide(currentSlide + 1, true);
        restartGalleryAutoplay();
      });
    }

    if (gallery && track) {
      gallery.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      gallery.addEventListener('touchend', function (e) {
        var delta = e.changedTouches[0].screenX - touchStartX;
        if (Math.abs(delta) < 40) return;
        goToSlide(delta < 0 ? currentSlide + 1 : currentSlide - 1, true);
        restartGalleryAutoplay();
      }, { passive: true });
    }

    startGalleryAutoplay();

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopGalleryAutoplay();
      else startGalleryAutoplay();
    });

    if (mainStage && window.matchMedia('(min-width: 1024px)').matches) {
      mainStage.addEventListener('click', function (e) {
        if (e.target.closest('video, iframe')) return;
        var img = mainStage.querySelector('img.pdp-gallery__main-image');
        if (!lightbox || !lightboxImage || !img) return;
        lightboxImage.src = img.src;
        lightbox.hidden = false;
      });
    }

    if (lightbox) {
      lightbox.addEventListener('click', function () {
        lightbox.hidden = true;
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !lightbox.hidden) lightbox.hidden = true;
      });
    }

    /* AJAX add to bag */
    function handleAtcClick(btn) {
      if (!btn || btn.disabled || btn.classList.contains('pdp-atc-button--oos')) return;

      if (config.requireSize && !kitSizeReady()) {
        if (atcError) {
          atcError.hidden = false;
          atcError.textContent = 'Please select a size';
        }
        return;
      }

      if (window.FabpadCombos && window.FabpadCombos.isActive()) {
        if (!window.FabpadCombos.isAvailable()) return;

        btn.disabled = true;
        btn.classList.add('is-loading');
        btn.textContent = 'ADDING...';
        if (atcError) atcError.hidden = true;

        window.FabpadCombos.addToCart()
          .then(function (data) {
            var after = window.FabpadCart && window.FabpadCart.afterAdd
              ? window.FabpadCart.afterAdd(data)
              : Promise.resolve();
            return after.then(function () {
              btn.classList.remove('is-loading');
              btn.classList.add('is-success');
              btn.textContent = 'ADDED ✓';
              window.setTimeout(function () {
                btn.classList.remove('is-success');
                btn.disabled = false;
                btn.textContent = 'Add to cart';
              }, 800);
            });
          })
          .catch(function () {
            btn.classList.remove('is-loading');
            btn.disabled = false;
            btn.textContent = 'Add to cart';
            if (atcError) {
              atcError.hidden = false;
              atcError.textContent = 'Could not add to bag. Please try again.';
            }
          });
        return;
      }

      var variantId = variantInput && variantInput.value;
      if (!variantId) return;

      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.textContent = 'ADDING...';
      if (atcError) atcError.hidden = true;

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(buildCartAddPayload(variantId, getQty()))
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add failed');
          return res.json();
        })
        .then(function (data) {
          var after = window.FabpadCart && window.FabpadCart.afterAdd
            ? window.FabpadCart.afterAdd(data)
            : Promise.resolve();
          return after.then(function () {
            btn.classList.remove('is-loading');
            btn.classList.add('is-success');
            btn.textContent = 'ADDED ✓';
            window.setTimeout(function () {
              btn.classList.remove('is-success');
              btn.disabled = false;
              btn.textContent = 'Add to cart';
            }, 800);
          });
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.disabled = false;
          btn.textContent = 'ADD TO BAG';
          if (atcError) {
            atcError.hidden = false;
            atcError.textContent = 'Could not add to bag. Please try again.';
          }
        });
    }

    if (mainAtc) {
      mainAtc.addEventListener('click', function (e) {
        e.preventDefault();
        handleAtcClick(mainAtc);
      });
    }

    if (stickyAtcBtn) {
      stickyAtcBtn.addEventListener('click', function (e) {
        e.preventDefault();
        handleAtcClick(stickyAtcBtn);
      });
    }

    var buyNowBtn = document.querySelector('[data-buy-it-now]');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function (e) {
        e.preventDefault();

        if (config.requireSize && !kitSizeReady()) {
          if (atcError) {
            atcError.hidden = false;
            atcError.textContent = 'Please select a size';
          }
          return;
        }

        if (window.FabpadCombos && window.FabpadCombos.isActive()) {
          if (!window.FabpadCombos.isAvailable()) return;
          buyNowBtn.disabled = true;
          window.FabpadCombos.addToCart()
            .then(function () {
              handleFloCheckoutBtn();
              buyNowBtn.disabled = false;
            })
            .catch(function () {
              buyNowBtn.disabled = false;
              if (atcError) {
                atcError.hidden = false;
                atcError.textContent = 'Could not proceed to checkout. Please try again.';
              }
            });
          return;
        }

        if (!variantInput || !variantInput.value) return;
        buyNowBtn.disabled = true;
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(buildCartAddPayload(variantInput.value, getQty()))
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add failed');
            handleFloCheckoutBtn();
            buyNowBtn.disabled = false;
          })
          .catch(function () {
            buyNowBtn.disabled = false;
            if (atcError) {
              atcError.hidden = false;
              atcError.textContent = 'Could not proceed to checkout. Please try again.';
            }
          });
      });
    }

    /* About this item — one accordion open at a time */
    var aboutAccordion = document.querySelector('[data-pdp-about-accordion]');
    if (aboutAccordion) {
      aboutAccordion.querySelectorAll('.pdp-about__item').forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          aboutAccordion.querySelectorAll('.pdp-about__item').forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    }

    /* Fallback: unstructured description split via headings in JS */
    var aboutContent = document.querySelector('[data-pdp-about-content]');
    if (aboutContent && !aboutAccordion) {
      var headings = aboutContent.querySelectorAll('h2, h3, h4');
      if (headings.length > 0) {
        var fragment = document.createDocumentFragment();
        headings.forEach(function (heading, index) {
          var title = heading.textContent.trim();
          if (!title) return;

          var bodyParts = [];
          var node = heading.nextElementSibling;
          while (node && !/^H[234]$/.test(node.tagName)) {
            bodyParts.push(node.cloneNode(true));
            node = node.nextElementSibling;
          }

          if (bodyParts.length === 0) return;

          var details = document.createElement('details');
          details.className = 'pdp-about__item';
          if (index === 0) details.open = true;

          var summary = document.createElement('summary');
          summary.className = 'pdp-about__summary';
          summary.innerHTML = '<span class="pdp-about__summary-text">' + title + '</span><span class="pdp-about__chevron" aria-hidden="true"><svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

          var body = document.createElement('div');
          body.className = 'pdp-about__body rte';
          bodyParts.forEach(function (part) {
            body.appendChild(part);
          });

          details.appendChild(summary);
          details.appendChild(body);
          fragment.appendChild(details);
        });

        if (fragment.childNodes.length > 0) {
          var wrapper = document.createElement('div');
          wrapper.className = 'pdp-about__accordion';
          wrapper.setAttribute('data-pdp-about-accordion', '');
          wrapper.appendChild(fragment);
          aboutContent.replaceWith(wrapper);

          wrapper.querySelectorAll('.pdp-about__item').forEach(function (item) {
            item.addEventListener('toggle', function () {
              if (!item.open) return;
              wrapper.querySelectorAll('.pdp-about__item').forEach(function (other) {
                if (other !== item) other.open = false;
              });
            });
          });
        }
      }
    }

    /* Sticky ATC — mobile only (hidden on desktop via CSS) */
    if (mainAtc && stickyAtc) {
      var stickyObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && window.matchMedia('(max-width: 1023px)').matches;
          stickyAtc.classList.toggle('is-visible', show);
          stickyAtc.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { threshold: 0, rootMargin: '0px' });
      stickyObserver.observe(mainAtc);
    }

    /* FAQ accordion — one open at a time */
    var faqItems = document.querySelectorAll('[data-faq-item]');
    faqItems.forEach(function (item) {
      var summary = item.querySelector('[data-faq-question]');
      if (!summary) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = item.classList.contains('is-open');
        faqItems.forEach(function (other) {
          other.classList.remove('is-open');
          var otherBtn = other.querySelector('[data-faq-question]');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          summary.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* Smooth scroll to reviews */
    var ratingLink = document.querySelector('[data-scroll-reviews]');
    if (ratingLink) {
      ratingLink.addEventListener('click', function (e) {
        var target = document.getElementById('looxReviews') || document.getElementById('reviews');
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }

    updateVariantUI();
    if (slides.length) {
      syncMainStage(currentSlide);
    }

    initPdpSplitScroll(pdp);
  });

  function initPdpSplitScroll(pdpRoot) {
    var aboveFold = pdpRoot.querySelector('.pdp__above-fold--split-scroll');
    if (!aboveFold) return;

    var buyBox = aboveFold.querySelector('.pdp-buy-box');
    if (!buyBox) return;

    var desktopQuery = window.matchMedia('(min-width: 1024px)');

    function buyBoxOverflows() {
      return buyBox.scrollHeight > buyBox.clientHeight + 2;
    }

    function atBottom() {
      return buyBox.scrollTop + buyBox.clientHeight >= buyBox.scrollHeight - 2;
    }

    function atTop() {
      return buyBox.scrollTop <= 2;
    }

    function isAboveFoldVisible() {
      var rect = aboveFold.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < window.innerHeight;
    }

    function overlayOwnsWheel(e) {
      if (document.querySelector('.cart-drawer.is-open, [data-cart-drawer].is-open')) return true;
      if (document.querySelector('.fabpad-nudge.is-open, [data-atc-nudge].is-open')) return true;
      var node = e && e.target;
      if (node && node.closest) {
        if (node.closest('.cart-drawer, [data-cart-drawer], .fabpad-nudge, [data-atc-nudge]')) return true;
      }
      return false;
    }

    window.addEventListener(
      'wheel',
      function (e) {
        if (!desktopQuery.matches || !buyBoxOverflows() || !isAboveFoldVisible()) return;
        if (overlayOwnsWheel(e)) return;

        var foldTop = aboveFold.getBoundingClientRect().top;

        if (e.deltaY > 0 && !atBottom()) {
          buyBox.scrollTop += e.deltaY;
          e.preventDefault();
          return;
        }

        if (e.deltaY < 0 && !atTop() && foldTop >= -2) {
          buyBox.scrollTop += e.deltaY;
          e.preventDefault();
        }
      },
      { passive: false }
    );
  }
})();
